import { getLabel } from "../labels";

export function getDaysLabels() {
    const days =  [
        getLabel('general.week_days.sun'),
        getLabel('general.week_days.mon'),
        getLabel('general.week_days.tue'),
        getLabel('general.week_days.wed'),
        getLabel('general.week_days.thu'),
        getLabel('general.week_days.fri'),
        getLabel('general.week_days.sat'),
    ];

    return days;
}
